module.exports = __webpack_public_path__ + "img/banner-bosspack.30fd348e.png";